import Lobby from './Lobby'

const Home = () => {
  return (
    <div className='new_home_page'>
      <Lobby />
    </div>
  )
}

export default Home
